module.exports = __webpack_public_path__ + "img/2.bba6bc79.png";